import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { lastValueFrom } from 'rxjs';
import { AppData } from '../helpers/app-data'
import { Router } from '@angular/router';
import { MsalService } from '@azure/msal-angular';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  private apiAuth = AppData.API_URL + 'Auth/Login'; 
  private apiAuthSSO = AppData.API_URL + 'Auth/LoginSSO'; 

  private isLoggedIn = false;

  constructor(private http: HttpClient,
    private router : Router,
    private msalService: MsalService
  ) {}

  async login(username: string, password?: string, AccessTokenSSO?: string): Promise<any> {
    // const body = { UserName: username, Password: password };
      const body: any = { UserName: username };
      if (password !== undefined) body.Password = password;
      if (AccessTokenSSO !== undefined) body.AccessTokenSSO = AccessTokenSSO;
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'X-APIKey': AppData.API_KEY,
        'AccessTokenSSO': AccessTokenSSO || ''
      }),
    };

    const response = await lastValueFrom(this.http.post<any>(this.apiAuth, body, httpOptions));
    return response;
  }

  async loginSSO(email: string): Promise<any> {
    const body = { Email: email };
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'X-APIKey': AppData.API_KEY
      }),
    };

    const response = await lastValueFrom(this.http.post<any>(this.apiAuthSSO, body, httpOptions));
    return response;
  }

  // Método para verificar si el usuario está autenticado
  isAuthenticated(): boolean {
    return this.isLoggedIn;
  }
  
  // Método para establecer el estado de autenticación
  setAuthentication(status: boolean): void {
    this.isLoggedIn = status;
  }

  logout(): void {
    
    sessionStorage.removeItem(AppData.localStorageToken);
    // Elimina todas las claves de MSAL en sessionStorage
    Object.keys(sessionStorage)
      .filter(key => key.startsWith('msal.'))
      .forEach(key => sessionStorage.removeItem(key));
    this.router.navigate(['/login']); // Redirigir a la página de inicio de sesión
  }

}
